module.exports = __webpack_public_path__ + "bd2442d2fc96fc199c4d97d345709444.pdf";